// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickFilterableTable_wrap__QYSrc {
  box-shadow: 1px 1px 5px var(--foreground-color-1-alpha);
  background: var(--foreground-color-1);
  border-radius: 0.5em;
  overflow: hidden;
  position: relative;
}
.ClickFilterableTable_wrap__QYSrc .ClickFilterableTable_filter__Oz55y {
  border-radius: 0;
  margin-bottom: 1em;
}
.ClickFilterableTable_wrap__QYSrc .ClickFilterableTable_table__FzPjR {
  border-radius: 0;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ClickFilterableTable/ClickFilterableTable.module.scss"],"names":[],"mappings":"AAAA;EACE,uDAAA;EACA,qCAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AACF;AAAE;EACE,gBAAA;EACA,kBAAA;AAEJ;AAAE;EACE,gBAAA;EACA,gBAAA;AAEJ","sourcesContent":[".wrap {\n  box-shadow: 1px 1px 5px var(--foreground-color-1-alpha);\n  background: var(--foreground-color-1);\n  border-radius: 0.5em;\n  overflow: hidden;\n  position: relative;\n  .filter {\n    border-radius: 0;\n    margin-bottom: 1em;\n  }\n  .table {\n    border-radius: 0;\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ClickFilterableTable_wrap__QYSrc`,
	"filter": `ClickFilterableTable_filter__Oz55y`,
	"table": `ClickFilterableTable_table__FzPjR`
};
export default ___CSS_LOADER_EXPORT___;
